module.exports = __webpack_public_path__ + "static/media/Portrait-10038.e6299925.jpg";